import { render, staticRenderFns } from "./sn-tip-caption.vue?vue&type=template&id=6acd4573"
import script from "./sn-tip-caption.vue?vue&type=script&lang=js"
export * from "./sn-tip-caption.vue?vue&type=script&lang=js"
import style0 from "./sn-tip-caption.vue?vue&type=style&index=0&id=6acd4573&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports